export default __webpack_public_path__ + "static/media/form-mail-golden.03e3151b.svg";